import { createI18n } from 'vue-i18n'

import en from './en-US.json'
import zhHans from './zh-Hans.json' // 简体中文

const messages = {
  en: {
    ...en,
    hoursXiaoShiMinutesFen: ({ named }) => `${named('hours')}hours${named('minutes')}min`,
    resdatanameresdataskus0skuXiZhiYueQuanQiuHuoPanWang: ({ named }) =>
      `${named('name')}-${named('sku')}-Xizhiyue Global Pallet Network`,
    yiFaSongDuanXinYanZhengMaDaoFormdatavalueareacodesplit_0PrivacyaccountformdatavaluephonePhone:
      ({ named }) =>
        `SMS verification code has been sent to: ${named('areaCode')} ${named('phone')}`,
    // 只包含{0}占位符的条目
    huoQuYanZhengMaSecondvalues: ({ named }) => `Get verification code (${named('second')}s)`,
    kuCunStocknum: ({ named }) => `Inventory: ${named('stockNum')}`,
    mathFloorItemPrice: ({ named }) => `${named('price')}`,
    mathFloorItemTotalFormat: ({ named }) => `￥${named('total')}`,
    orderinfoFreight: ({ named }) => `￥${named('freight')}`,
    orderinfoOrdertotal: ({ named }) => `￥${named('orderTotal')}`,
    orderinfoTotal: ({ named }) => `￥${named('orderinfoTotal')}`,
    quanBuSelectedidslength_0: ({ named }) => `All(${named('length')})`,
    shangPinZongJi_1ZhongNumJian: ({ named }) =>
      `Total products: 1 type ${named('quantity')} pieces`,
    shiFouShanChuZheIdlengthGeShangPin: ({ named }) =>
      `Should these ${named('length')} products be deleted?`,
    skuItemProductSku: ({ named }) => `SKU:${named('sku')}`,
    skuItemsProductSku: ({ named }) => `sku:${named('sku')}`,
    skuSku: ({ named }) => `SKU：${named('sku')}`,
    xItemQuantity: ({ named }) => `X${named('quantity')}`,
    yiFaSongYanZhengMaDaoPrivacyaccountformdatavalueemailEmail: ({ named }) =>
      `The verification code has been sent to: ${named('email')}`,
    parsefloatProductMemberPriceGreaterThan0ProductMemberPriceProductBasePrice1Tofixed2TostringSlice2:
      ({ named }) => `.${named('value')}`,
    parsefloatProductMemberPriceGreaterThan_0ProductMemberPriceProductBasePrice_1Tofixed_2TostringSlice_2:
      ({ named }) => `.${named('value')}`,
    xProductlistQuantity: ({ named }) => `X${named('quantity')}`,
    productlistPrice1Tofixed2Slice20: ({ named }) => `.${named('price')}`,
    mathFloorProductlistPrice: ({ named }) => `￥${named('price')}`,
    productlistPrice1Tofixed2Slice2: ({ named }) => `.${named('price')}`,
    qingZaiTimetextNeiWanChengZhiFu2: ({ named }) =>
      `Please complete the payment within ${named('time')}`,
    qingZaiTimetextNeiWanChengZhiFu1: ({ named }) =>
      `Please complete the payment within ${named('time')}`,
    tatolmoney1Tofixed2Slice20: ({ named }) => `.${named('money')}`,
    yiFaSongDuanXinYanZhengMaDaoFormdatavalueareacodesplit0PrivacyaccountformdatavaluephonePhone: ({
      named,
    }) => `SMS verification code has been sent to: ${named('areaCode')} ${named('phone')}`,
    itemTotalFormat1Tofixed2Slice2: ({ named }) => `.${named('total')}`,
    shangPinZongJi1ZhongNumJian: ({ named }) =>
      `Total products: 1 type ${named('quantity')} pieces`,
    itemBasePriceView1Tofixed2Slice20: ({ named }) => `.${named('price')}`,
    itemPreferentialPriceView1Tofixed2Slice20: ({ named }) => `.${named('price')}`,
    parsefloatPriceinfoProductpriceview1Tofixed2Slice20: ({ named }) => `.${named('price')}`,
    parsefloatPriceinfoTotalpriceview1Tofixed2Slice20: ({ named }) => `.${named('price')}`,
    priceinfoDiscounttypeview1: ({ named }) => `${named('type')}:`,
    yueXiaoProductdetailsmonthsale: ({ named }) => `Monthly sales: ${named('sales') ?? '--'}`,
    itemQuantity: ({ named }) => `·${named('quantity')}`,
    key_1JianZhiDaoJiaPriceinfoguidepriceview: ({ named }) =>
      `1 piece guide price ${named('price')}`,
    itemBasePriceView1Tofixed2Slice2: ({ named }) => `.${named('price')}`,
    itemPreferentialPriceView1Tofixed2Slice2: ({ named }) => `.${named('price')}`,
    priceinfoDiscounttypeview0: ({ named }) => `${named('type')}:`,
    parsefloatPriceinfoProductpriceview1Tofixed2Slice2: ({ named }) => `.${named('price')}`,
    parsefloatPriceinfoTotalpriceview1Tofixed2Slice2: ({ named }) => `.${named('price')}`,
    priceinfoDiscounttypeview: ({ named }) => `${named('type')}:`,
    parsefloatTotalamount1Tofixed2Slice2: ({ named }) => `.${named('amount')}`,
    userstoreisloginDengLuHouKeChaKanYiJiaGouShangPinZanWuShangPin: ({ named }) =>
      `- ${named('store')} -`,
    itemsPriceItemsPriceItemsBasePrice1Tofixed2Slice2: ({ named }) => `.${named('price')}`,
    quanBuSelectedidslength0: ({ named }) => `All(${named('length')})`,
    jianOrderinfodiscountamount: ({ named }) => `-￥${named('amount')}`,
    productinfoslengthZhong: ({ named }) => `${named('length')} types`,
    xItemQuantity0: ({ named }) => `X${named('quantity')}`,
    itemPrice1Tofixed2Slice2: ({ named }) => `.${named('price')}`,
    parsefloatPriceinfoProductpriceview_1Tofixed_2Slice_2: ({ named }) => `.${named('price')}`,
    dingDanHaoItemnumber: ({ named }) => `Order number：${named('number')}`,
    formpersonidcardtype_1ShenFenZhengHaoZhengJianHao: ({ named }) =>
      `${named('id_card_type') === 1 ? 'ID number' : 'Dict number'}`,
  },
  'zh-Hans': {
    ...zhHans,
    hoursXiaoShiMinutesFen: ({ named }) => `${named('hours')}小时${named('minutes')}分`,
    resdatanameresdataskus0skuXiZhiYueQuanQiuHuoPanWang: ({ named }) =>
      `${named('name')}-${named('sku')}-西之月全球货盘网`,
    yiFaSongDuanXinYanZhengMaDaoFormdatavalueareacodesplit_0PrivacyaccountformdatavaluephonePhone:
      ({ named }) => `已发送短信验证码到：${named('areaCode')} ${named('phone')}`,
    // 只包含{0}占位符的条目
    huoQuYanZhengMaSecondvalues: ({ named }) => `获取验证码（${named('second')}s）`,
    kuCunStocknum: ({ named }) => `库存：${named('stockNum')}`,
    mathFloorItemPrice: ({ named }) => `￥${named('price')}`,
    mathFloorItemPriceDetail: ({ named }) => `.${named('price')}`,
    mathFloorItemTotalFormat: ({ named }) => `￥${named('total')}`,
    orderinfoFreight: ({ named }) => `￥${named('freight')}`,
    orderinfoOrdertotal: ({ named }) => `￥${named('orderTotal')}`,
    orderinfoTotal: ({ named }) => `￥${named('orderinfoTotal')}`,
    quanBuSelectedidslength_0: ({ named }) => `全部(${named('length')})`,
    shangPinZongJi_1ZhongNumJian: ({ named }) => `商品总计：1种${named('quantity')}件`,
    shiFouShanChuZheIdlengthGeShangPin: ({ named }) => `是否删除这${named('length')}个商品？`,
    skuItemProductSku: ({ named }) => `SKU:${named('sku')}`,
    skuItemProductsku: ({ named }) => `SKU: ${named('sku')}`,
    skuItemsProductSku: ({ named }) => `sku:${named('sku')}`,
    skuSku: ({ named }) => `SKU：${named('sku')}`,
    xItemQuantity: ({ named }) => `X${named('quantity')}`,
    xItemQuantity_0: ({ named }) => `X${named('quantity')}`,
    yiFaSongYanZhengMaDaoPrivacyaccountformdatavalueemailEmail: ({ named }) =>
      `已发送验证码到：${named('email')}`,
    parsefloatProductMemberPriceGreaterThan0ProductMemberPriceProductBasePrice1Tofixed2TostringSlice2:
      ({ named }) => `.${named('value')}`,
    parsefloatProductMemberPriceGreaterThan_0ProductMemberPriceProductBasePrice_1Tofixed_2TostringSlice_2:
      ({ named }) => `.${named('value')}`,
    xProductlistQuantity: ({ named }) => `X${named('quantity')}`,
    productlistPrice1Tofixed2Slice20: ({ named }) => `.${named('price')}`,
    mathFloorProductlistPrice: ({ named }) => `￥${named('price')}`,
    productlistPrice1Tofixed2Slice2: ({ named }) => `.${named('price')}`,
    qingZaiTimetextNeiWanChengZhiFu2: ({ named }) => `请在 ${named('time')} 内完成支付`,
    qingZaiTimetextNeiWanChengZhiFu1: ({ named }) => `请在 ${named('time')} 内完成支付`,
    tatolmoney1Tofixed2Slice20: ({ named }) => `.${named('money')}`,
    yiFaSongDuanXinYanZhengMaDaoFormdatavalueareacodesplit0PrivacyaccountformdatavaluephonePhone: ({
      named,
    }) => `已发送短信验证码到：${named('areaCode')} ${named('phone')}`,
    itemTotalFormat1Tofixed2Slice2: ({ named }) => `.${named('total')}`,
    shangPinZongJi1ZhongNumJian: ({ named }) => `商品总计：1种${named('quantity')}件`,
    itemBasePriceView1Tofixed2Slice20: ({ named }) => `.${named('price')}`,
    itemPreferentialPriceView1Tofixed2Slice20: ({ named }) => `.${named('price')}`,
    parsefloatPriceinfoProductpriceview1Tofixed2Slice20: ({ named }) => `.${named('price')}`,
    parsefloatPriceinfoTotalpriceview1Tofixed2Slice20: ({ named }) => `.${named('price')}`,
    priceinfoDiscounttypeview1: ({ named }) => `${named('type')}：`,
    yueXiaoProductdetailsmonthsale: ({ named }) => `月销：${named('sales') ?? '--'}`,
    itemQuantity: ({ named }) => `·${named('quantity')}`,
    key_1JianZhiDaoJiaPriceinfoguidepriceview: ({ named }) => `1件指导价${named('price')}`,
    itemBasePriceView1Tofixed2Slice2: ({ named }) => `.${named('price')}`,
    itemPreferentialPriceView1Tofixed2Slice2: ({ named }) => `.${named('price')}`,
    priceinfoDiscounttypeview0: ({ named }) => `${named('type')}：`,
    parsefloatPriceinfoProductpriceview1Tofixed2Slice2: ({ named }) => `.${named('price')}`,
    parsefloatPriceinfoTotalpriceview1Tofixed2Slice2: ({ named }) => `.${named('price')}`,
    priceinfoDiscounttypeview: ({ named }) => `${named('type')}：`,
    parsefloatTotalamount1Tofixed2Slice2: ({ named }) => `.${named('amount')}`,
    userstoreisloginDengLuHouKeChaKanYiJiaGouShangPinZanWuShangPin: ({ named }) =>
      `- ${named('store')} -`,
    itemsPriceItemsPriceItemsBasePrice1Tofixed2Slice2: ({ named }) => `.${named('price')}`,
    quanBuSelectedidslength0: ({ named }) => `全部(${named('length')})`,
    jianOrderinfodiscountamount: ({ named }) => `减￥${named('amount')}`,
    productinfoslengthZhong: ({ named }) => `${named('length')} 种`,
    xItemQuantity0: ({ named }) => `X${named('quantity')}`,
    itemPrice1Tofixed2Slice2: ({ named }) => `.${named('price')}`,
    parsefloatPriceinfoProductpriceview_1Tofixed_2Slice_2: ({ named }) => `.${named('price')}`,
    dingDanHaoItemnumber: ({ named }) => `订单号：${named('number')}`,
    formpersonidcardtype_1ShenFenZhengHaoZhengJianHao: ({ named }) =>
      `${named('id_card_type') === 1 ? '身份证号' : '证件号'}`,
  },
}

const i18n = createI18n({
  legacy: false,
  locale: uni.getLocale(), // 获取已设置的语言，fallback 语言需要再 manifest.config.ts 中设置
  messages,
  allowComposition: true,
  globalInjection: true,
})

console.log(uni.getLocale())
console.log(i18n.global.locale)

/**
 * 可以拿到原始的语言模板，非 vue 文件使用这个方法，
 * @param { string } key 多语言的key，eg: "app.name"
 * @returns {string} 返回原始的多语言模板，eg: "{heavy}KG"
 */
export const getTemplateByKey = (key: string) => {
  if (!key) {
    console.error(`[i18n] Function getTemplateByKey(), key param is required`)
    return ''
  }
  const locale = uni.getLocale()

  const message = messages[locale] // 拿到某个多语言的所有模板（是一个对象)
  if (Object.keys(message).includes(key)) {
    return message[key]
  }

  try {
    const keyList = key.split('.')
    return keyList.reduce((pre, cur) => {
      return pre[cur]
    }, message)
  } catch (error) {
    console.error(`[i18n] Function getTemplateByKey(), key param ${key} is not existed.`)
    return ''
  }
}

/**
 * formatI18n('我是{name},身高{detail.height},体重{detail.weight}',{name:'张三',detail:{height:178,weight:'75kg'}})
 * 暂不支持数组
 * @param template 多语言模板字符串，eg: `我是{name}`
 * @param {Object|undefined} data 需要传递的数据对象，里面的key与多语言字符串对应，eg: `{name:'菲鸽'}`
 * @returns
 */
function formatI18n(template: string, data?: any) {
  return template.replace(/\{([^}]+)\}/g, function (match, key: string) {
    // console.log( match, key) // => { detail.height }  detail.height
    const arr = key.trim().split('.')
    let result: any = data
    while (arr.length) {
      const first = arr.shift()
      if (first && result) {
        result = result[first]
      }
    }
    return result
  })
}

/**
 * t('introduction',{name:'张三',detail:{height:178,weight:'75kg'}})
 * => formatI18n('我是{name},身高{detail.height},体重{detail.weight}',{name:'张三',detail:{height:178,weight:'75kg'}})
 * 没有key的，可以不传 data；暂不支持数组
 * @param template 多语言模板字符串，eg: `我是{name}`
 * @param {Object|undefined} data 需要传递的数据对象，里面的key与多语言字符串对应，eg: `{name:'菲鸽'}`
 * @returns
 */
export function t(key, data?) {
  return formatI18n(getTemplateByKey(key), data)
}

export default i18n
